import React, { Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';
import Loading from '@/shared/components/Loading';
import { paths } from '@/shared/helpers/paths';
import { EmailPage } from './components/EmailPage';

export const cadsAiEmailBaseUrl = paths.CADS_AI.EMAIL;

const Emails = () => {
  return (
    <Suspense fallback={<Loading />}>
      <Switch>
        <Route path={cadsAiEmailBaseUrl} component={EmailPage} />
      </Switch>
    </Suspense>
  );
};

export default Emails;
